import styled from 'styled-components';
import font from '../../styles/font';

export const Text = styled.div`
  ${() => font.medium_17};

  margin-bottom: 1rem;
`;
